<template>
    <div :style="columns === 1 ? 'max-width: calc(50% - 8px);' : ''">
        <div class="treatment-option-selector--button" :class="[parseInt(value.selected) === 1 ? 'treatment-option-selector--button--active' : 'treatment-option-selector--button--inactive', $theme.dark ? 'dark' : 'light']">
            <div class="treatment-option-selector--amount roboto f11">
                <template v-if="value.isProtocolVariation === 1 && value.fullJaw">{{ $t('plan_calculator.package_price', {n: $t("plan_simple.template_"+value.tpl)}) }}</template>
                <template v-else-if="value.fullJaw && [315].includes(parseInt(pid))">{{ $t("plan_calculator.option_" + pid) }}</template>
                <template v-else-if="value.fullJaw && [9,15].includes(parseInt(pid))">{{ amount }} {{ $t("plan_calculator.bridge_final") }}</template>
                <!--template v-else-if="value.isProtocolVariation === 1 && value.fullJaw">{{ $t('plan_calculator.package_price') }} ({{ amount }} {{ $t('plan_calculator.option_' + pid) }})</template-->
                <template v-else>{{ amount }} {{ getTitle() }}</template>
            </div>
            <div class="roboto f15 treatment-option-selector--title">
                {{ title }}
            </div>
            <div :class="parseInt(value.selected) === 1 ? '' : 'grey--text'" class="treatment-option-selector--price">
                <pm-price v-if="parseInt(value.batch_price) === 1" style="font-weight: 600;" :value="value.unit_price" :currency="$store.state.currency" />
                <pm-price v-else style="font-weight: 600;" :value="amount * value.unit_price" :currency="$store.state.currency" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
     .treatment-option-selector--button {
        font-size: 12px;
        border-radius: 8px;
        padding: 10px 12px;
        margin: 0 0 14px 0;
         overflow: hidden;
         white-space: nowrap;
         border: 2px solid #dfe1e3;
     }

     .treatment-option-selector--amount {
         margin-bottom: 6px;
         text-overflow: ellipsis;
         overflow: hidden;
     }

     .treatment-option-selector--title {
        margin-top: -4px;
     }

     .treatment-option-selector--button--inactive {
         .treatment-option-selector--amount {
            color: rgba(184, 186, 190, 1);
         }
         .treatment-option-selector--title {
            color: rgba(123, 128, 136, 1);
         }
     }

     .treatment-option-selector--button--active {
         border: 2px solid rgba(40, 98, 230, 1);

         .treatment-option-selector--amount {
            color: rgba(123, 128, 136, 1);
         }
         .treatment-option-selector--title {
            color: rgba(0, 0, 0, 1);
         }
     }

    .treatment-option-selector--title {
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        margin-bottom: 3px;
    }

    .treatment-option-selector--price {
        font-size: 13px;
    }

    @media (max-width: 480px) {
        .treatment-option-selector--title {
            white-space: initial;
            line-height: 16px;
            height: 34px;
        }

        .treatment-option-column.xs12 .treatment-option-selector--title {
            height: auto;
        }
    }

@media (min-width: 700px) {
    .treatment-option-selector--button {
        height: 100px;
    }

    .treatment-option-selector--amount {
        font-size: 14px;
    }

    .treatment-option-selector--title {
        font-size: 18px;
        margin-top: -4px;
    }

    .treatment-option-selector--price {
        margin-top: -4px;
        font-size: 18px;
    }
}
</style>

<script>import { captureException } from "@/utils/capture-exception";

export default {
    props: {
        value: {
            type: Object,
            default: () => {return ({});},
        },
        pid: {
            type: String,
            default: "",
        },
        amount: {
            type: Number,
            default: 0,
        },
        columns: {
            type: Number,
            default: 1,
        },
        optionGroup: {
            type: Object,
            default: () => {
                return ({});
            },
        },
    },
    computed: {
        title() {
            if (typeof this.value.variation_index !== "undefined") {
                return this.$store.state.localSettings.protocols[this.value.tpl].variation_titles[parseInt(this.value.variation_index)][this.$store.state.language] || this.$t("settings.type_treatment");
            }
            return this.$store.state.dentalStates[String(this.value.state_id)].title[this.$store.state.language] || this.$t("settings.type_treatment");
        },
    },
    methods: {
        getTitle() {
            try {
                if (this.pid === 9 && this.optionGroup.bridgeCount === 0) return this.$t('plan_calculator.state_9');
                if (this.pid === 15 && this.optionGroup.bridgeCount === 0) return this.$t('plan_calculator.state_9');
                if (this.pid === 9 && this.optionGroup.crownCount === 0) return this.$t('plan_calculator.state_15');
                if (this.pid === 15 && this.optionGroup.crownCount === 0) return this.$t('plan_calculator.state_15');
            } catch (e) {
                window.captureException(e);
            }
            return this.$t('plan_calculator.option_' + this.pid);
        }
    },
};
</script>
